// --- 账号管理 --- //

export default [
  {
    name: 'accountList',
    path: '/supplySystem/accountManagement/accountList',
    meta: { title: '账号列表' },
    component: require('business/supplySystem/accountManagement/accountList/list.vue').default
  },
  {
    name: 'roleConfiguration',
    path: '/supplySystem/accountManagement/roleConfiguration',
    meta: { title: '角色配置' },
    component: require('business/supplySystem/accountManagement/roleConfiguration/list.vue').default
  }
]
